import { alo7Nav } from '../alo7Nav';

export default (router: any) => () => {
  const truncate = alo7Nav.paths.length - 1;
  const currentHistory = router.current.history;
  const routerStyleUrl = alo7Nav.toRouterStyle(
    alo7Nav.location.pathname + alo7Nav.location.search,
    truncate
  );

  router.current.history.replace(routerStyleUrl);
  const routerChange = ({ path }: { path: string }) => {
    const truncate = alo7Nav.paths.length - 1;
    const url = alo7Nav.toRouterStyle(path, truncate);
    // slow: https://github.com/vercel/next.js/issues/9799
    setTimeout(() => currentHistory.push(url), 0);
    nx.$event.emit('url.change');
  };

  alo7Nav.eventemitter.addListener('popstate', routerChange);
  return () => alo7Nav.eventemitter.removeListener('popstate', routerChange);
};
